import { render, staticRenderFns } from "./RecordingStep.vue?vue&type=template&id=580f73d4&scoped=true"
import script from "./RecordingStep.vue?vue&type=script&lang=js"
export * from "./RecordingStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f73d4",
  null
  
)

export default component.exports